<template>
    <label
        class="f-formCheckbox k-c-checkbox f-formCheckbox__checkbox f-formCheckbox__cursorPointer"
        v-bind="{ class: $attrs.class }"
        :for="id"
        :data-qa="$attrs['data-qa'] ? `${$attrs['data-qa']} label` : undefined"
        :class="{
            'k-c-checkbox--error has-status-error': error,
        }"
    >
        <input
            :id="id"
            v-bind="{ ...$attrs, class: undefined }"
            type="checkbox"
            :checked="modelValue"
            class="k-c-checkbox__input f-formCheckbox__cursorPointer"
            @change="updateInput"
        >
        <div
            :class="{
                'is-checked': modelValue,
            }"
            data-qa="icon"
            class="k-c-checkbox__box f-formCheckbox__box"
        >
            <AppIcon
                class="k-c-checkbox__icon f-formCheckbox__checkIcon"
                name="check"
            />
        </div>
        <div class="k-c-checkbox__label f-formCheckbox__label">
            <slot/>
        </div>
    </label>
</template>

<script setup>
import AppIcon from '../app/AppIcon.vue';

defineProps({
    id: {
        type: String,
    },
    modelValue: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);
const updateInput = e => emit('update:modelValue', e.target.checked);
</script>

<script>
export default {
    inheritAttrs: false,
};
</script>

<style lang="scss">
$checkbox-visual-spacing: 1px;

.f-formCheckbox {
    &__cursorPointer {
        cursor: pointer;
    }

    &__checkbox {
        width: 100%;
    }

    &__checkIcon {
        color: var(--k-white);
    }

    &__label {
        min-width: 0;
        width: 100%;
    }

    &__box {
        margin-top: $checkbox-visual-spacing;

        :checked ~ & {
            border: 1px solid var(--k-gray-900) !important;
            background-color: var(--k-gray-900) !important;
        }
    }
}
</style>
